import {
    IStorageMock
} from './index'

export const mockStorage = (): IStorageMock => ({
    getters: {
        getPlatformInfo: jest.fn(),
        getAllCurrencies: jest.fn(),
        getCurrentCurrency: jest.fn(),
        getPriceLabel: jest.fn(),
        wrapPriceLabel: jest.fn(),
        getTravel: jest.fn(),
        // getModal: jest.fn(),
        getOrder: jest.fn(),

        getLocaleDate: jest.fn()
    },

    actions: {
        updatePlatformInfo: jest.fn(),

        fetchServiceTypes: jest.fn(),
        getServiceTypeById: jest.fn(),
        fetchServiceTypePrices: jest.fn(),
        getServiceTypePriceById: jest.fn(),

        fetchSolutions: jest.fn(),
        getSolutionById: jest.fn(),

        setRequestServiceContact: jest.fn(),
        getRequestServiceHistories: jest.fn(),

        fetchCurrencies: jest.fn(),
        setCurrency: jest.fn(),
        getPrice: jest.fn(),
        setTravel: jest.fn(),
        setFilters: jest.fn(),

        fetchTravels: jest.fn(),
        getTravelById: jest.fn(),
        getTravelLimits: jest.fn(),

        // criteria
        fetchCriterion: jest.fn(),

        fetchAccommodation: jest.fn(),
        getAccommodationById: jest.fn(),

        fetchTravelType: jest.fn(),
        getTravelTypeById: jest.fn(),

        fetchTaste: jest.fn(),
        getTasteById: jest.fn(),

        fetchLocation: jest.fn(),
        getLocationById: jest.fn(),

        fetchSeason: jest.fn(),
        getSeasonById: jest.fn(),


        fetchPartners: jest.fn(),
        getPartnerById: jest.fn(),

        fetchContactWays: jest.fn(),
        getContactWayById: jest.fn(),

        fetchFaqItems: jest.fn(),
        getFaqItemById: jest.fn(),

        fetchNews: jest.fn(),
        getNewsById: jest.fn(),

        fetchBeautyPlaces: jest.fn(),
        getBeautyPlaceById: jest.fn(),

        addContactRequest: jest.fn(),

        setModal: jest.fn(),
        closeModal: jest.fn(),

        addServiceOrder: jest.fn(),
        addPublicPlanOrder: jest.fn(),
        addPlanOrder: jest.fn(),
        addSolutionOrder: jest.fn(),
        addPromoCodeOrder: jest.fn(),

        getOrderByToken: jest.fn(),
        addConsultationInfo: jest.fn(),
        getOrderHistories: jest.fn(),
        getRequestTravelHistories: jest.fn(),
        appendService: jest.fn(),
        cancelOrder: jest.fn(),

        fetchPromoCodes: jest.fn(),
        getRequestPromoCodeHistories: jest.fn(),

        setOrder: jest.fn(),

        checkout: jest.fn(),

        setLoading: jest.fn(),
        setTheming: jest.fn(),
        setTheme: jest.fn()
    },

    mutations: {
        fetchCurrencies: jest.fn(),
        setCurrency: jest.fn(),

        setModal: jest.fn(),
        setOrder: jest.fn(),

        setPlatformInfo: jest.fn(),
        setTravel: jest.fn(),
        setFilters: jest.fn(),

        setLoading: jest.fn(),
        setTheming: jest.fn(),
        setTheme: jest.fn()
    }
})